import { render } from "./ROIModal.vue?vue&type=template&id=48bb0be4&scoped=true"
import script from "./ROIModal.vue?vue&type=script&lang=js"
export * from "./ROIModal.vue?vue&type=script&lang=js"

import "./ROIModal.vue?vue&type=style&index=0&id=48bb0be4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bb0be4"]])

export default __exports__